module.exports = __webpack_public_path__ + "static/media/team.7bd16442.png";